import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import DestinationFilter, { filterBy } from './destinations-filter';
import Port from './port';
import Token from './token';

const discouragePorts = PT.Utils.featureActive('discourage_ports');

const MissingDestinations = (props) => {
  if (!props.active) return null;

  return (
    <div className="empty">
      <p>
        Before getting logs into Papertrail, you need at least one destination.
        So far, none have been created for this account.
      </p>
      <p className="btn-links">
        <a href="/destinations/new" className="mod-primary">Create Log Destination</a>
      </p>
    </div>
  );
}

class Destinations extends React.Component {
  static propTypes = {
    ports: PropTypes.array.isRequired
  };

  state = {
    destinations: this.props.ports
  };

  ports = this.props.ports.filter(port => !port.tokenAuth);
  tokens = this.props.ports.filter(port => port.tokenAuth);

  onFilterChange = (selected) => {
    let destinations = [];
    const link = document.querySelector("[href^='/destinations/new']");

    switch (Number(selected)) {
      case filterBy.PORT:
        destinations = this.ports;
        link.setAttribute("href", "/destinations/new")
        break;
      case filterBy.TOKEN:
        destinations = this.tokens;
        link.setAttribute("href", "/destinations/new?token=true")
        break;
      default:
        destinations = this.props.ports;
        link.setAttribute("href", `/destinations/new${discouragePorts ? '?token=true' : ''}`)
    }
    this.setState({ destinations });
  }

  render() {
    const { destinations } = this.state;

    return (
      <div className="destinations-wrapper">
        <DestinationFilter
          portCount={this.ports.length}
          tokenCount={this.tokens.length}
          onFilterChange={this.onFilterChange}
        />

        <MissingDestinations active={this.props.ports.length === 0} />

        <div className="list port-list">
          {
            destinations.map(destination =>
              destination.tokenAuth
                ? <Token key={destination.id} destination={destination} />
                : <Port key={destination.id} destination={destination} />
            )
          }
        </div>
      </div>
    );
  }
};

$(function() {
  ReactDOM.render(
    <Destinations ports={PT.ports} />,
    document.getElementById('destinations-list')
  );
});
